<template>
  <div class="color-chooser">
    <div
      v-for="color in mappedColors"
      :key="color.colorName"
      class="color-button-wrapper"
    >
      <div
        v-if="color.colorKey === 'regenbogen'"
        class="color-button rainbow"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
      <div
        v-else-if="color.colorKey === 'farbspiel1'"
        class="color-button farbspiel-1"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
      <div
        v-else-if="color.colorKey === 'farbspiel2'"
        class="color-button farbspiel-2"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
      <div
        v-else-if="color.colorKey === 'farbspiel3'"
        class="color-button farbspiel-3"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
      <div
        v-else-if="color.colorKey === 'farbspiel4'"
        class="color-button farbspiel-4"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
      <div
        v-else
        class="color-button"
        :style="{ backgroundColor: color.colorKey }"
        :class="{ active: selected === color.colorName }"
        @click="assignColor(color)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorChooser",
  props: {
    colors: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    selectedcolor: { type: Object, default: () => {} }
  },
  data() {
    return {
      selected: "",
      mappedColors: []
    };
  },
  mounted() {
    this.mapColors(this.colors);
    if (typeof this.selectedcolor !== "undefined") {
      this.selected = this.selectedcolor.colorName;
    }
  },
  methods: {
    assignColor(color) {
      this.selected = color.colorName;
      this.$emit("input", color, this.index);
    },
    mapColors(colorArray) {
      for (let i = 0; i < colorArray.length; i++) {
        switch (colorArray[i].value_description) {
          case "rot":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#e63232",
              values: colorArray[i].values
            });
            break;
          case "grün":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#8cc83c",
              values: colorArray[i].values
            });
            break;
          case "blau":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#14b4f0",
              values: colorArray[i].values
            });
            break;
          case "weiß":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#e6e6e6",
              values: colorArray[i].values
            });
            break;
          case "gelb":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#f0dc1e",
              values: colorArray[i].values
            });
            break;
          case "magenta":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#dc00dc",
              values: colorArray[i].values
            });
            break;
          case "cyan":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "#00dcdc",
              values: colorArray[i].values
            });
            break;
          case "Regenbogen":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "regenbogen",
              values: colorArray[i].values
            });
            break;
          case "cyan-magenta-gelb":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "farbspiel1",
              values: colorArray[i].values
            });
            break;
          case "blau-weiß":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "farbspiel2",
              values: colorArray[i].values
            });
            break;
          case "gelb-rot":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "farbspiel3",
              values: colorArray[i].values
            });
            break;
          case "cyan-magenta":
            this.mappedColors.push({
              colorName: colorArray[i].value_description,
              colorKey: "farbspiel4",
              values: colorArray[i].values
            });
            break;
        }
      }
    }
  }
};
</script>

<style scoped>
.color-chooser {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.color-button {
  height: 30px;
  width: 70px;
  border: none;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.color-button:hover {
  cursor: pointer;
  border: 2px solid #2c3e50;
}

.color-button.active {
  border: 3px solid white;
}

.color-button-wrapper {
  padding: 5px;
}

@media (max-width: 575px) {
  .color-button {
    width: 85px;
    height: 35px;
  }
}
</style>
